import { NoteEntity } from '../../coaching-base/config';
import { CoachingTranscript } from '../../coaching-base/general';
import { BehaviourItem } from '../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../coaching-tags/models/subbehaviour.coaching.model';
import { TranscriptQuote } from '../../teams-call';

import { View } from './enum/view.enum';
import { AllowedActions } from './model/allowed-actions.model';
import { BehaviourTag } from './model/behaviour-tag.model';
import { FilterOptions } from './model/filter-options.model';

export interface TranscriptDialogState {
    pending: {
        reload?: boolean;
        updateTranscript?: boolean;
    };
    summaryEnabled?: boolean;
    evaluationEnabled?: boolean;
    hasCoachAssist?: boolean;
    hasDesc?: boolean;
    view?: View;
    allowedActions?: AllowedActions;
    transcript?: CoachingTranscript;
    filteredQuotes?: TranscriptQuote[];
    filterOpts: FilterOptions;
    sliderOptions: {
        floorNum: number;
        ceilNum: number;
    };
    selectedQuotes?: TranscriptQuote[];
    filteredQuotesSelectedLookup: { [index: number]: boolean };
    allQuotesAreSelected?: boolean;
    didAddCommitmentNoteViaSummary?: boolean;
    didAddObservationNoteViaSummary?: boolean;
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    noteEntity?: NoteEntity;
    primaryFocusTag?: BehaviourTag;
    behaviourTags?: BehaviourTag[];
    cmtNotesFocus?: BehaviourTag;
    navigateCmtId?: number;
    navigateDraftId?: string;
    willNavigate: boolean | null;
}

export const defaultState = (): TranscriptDialogState => ({
    pending: {},
    view: View.LANDING,
    filterOpts: {},
    sliderOptions: {
        floorNum: 0,
        ceilNum: 1,
    },
    filteredQuotesSelectedLookup: {},
    willNavigate: null,
    navigateCmtId: null,
    navigateDraftId: null,
    cmtNotesFocus: null,
});
